export enum PostPublishStep {
  Done,
  ServerRefresh,
  OnlineSyncRefresh,
  OnlineLiveQuerySync,
  ServerTriggeredClientRefresh,
}